export const results = {
  jobName: 'podcast-test',
  accountId: '573000482831',
  results: {
    language_code: 'en-NZ',
    transcripts: [
      {
        transcript:
          "Hello and welcome to Episode 100 Forty-nine of my Uncles Grand Podcast, a weekly podcast where we figure out what we think is going on and figure out what we think about stuff and talk about stuff. My name is Michael Forest, and I'm magic."
      }
    ],
    language_identification: [
      { score: '0.5141', code: 'en-NZ' },
      { score: '0.2378', code: 'en-GB' },
      { score: '0.1256', code: 'en-WL' },
      { score: '0.0746', code: 'en-IE' },
      { score: '0.0479', code: 'en-AB' }
    ],
    items: [
      {
        start_time: '0.0',
        end_time: '0.16',
        alternatives: [{ confidence: '0.4645', content: 'Hello' }],
        type: 'pronunciation'
      },
      {
        start_time: '0.16',
        end_time: '0.25',
        alternatives: [{ confidence: '0.705', content: 'and' }],
        type: 'pronunciation'
      },
      {
        start_time: '0.25',
        end_time: '0.74',
        alternatives: [{ confidence: '1.0', content: 'welcome' }],
        type: 'pronunciation'
      },
      {
        start_time: '0.74',
        end_time: '0.86',
        alternatives: [{ confidence: '0.9988', content: 'to' }],
        type: 'pronunciation'
      },
      {
        start_time: '0.87',
        end_time: '1.48',
        alternatives: [{ confidence: '0.9987', content: 'Episode' }],
        type: 'pronunciation'
      },
      {
        start_time: '1.48',
        end_time: '1.91',
        alternatives: [{ confidence: '1.0', content: '100' }],
        type: 'pronunciation'
      },
      {
        start_time: '2.0',
        end_time: '2.91',
        alternatives: [{ confidence: '0.9789', content: 'Forty-nine' }],
        type: 'pronunciation'
      },
      {
        start_time: '2.92',
        end_time: '3.17',
        alternatives: [{ confidence: '0.9113', content: 'of' }],
        type: 'pronunciation'
      },
      {
        start_time: '3.17',
        end_time: '3.39',
        alternatives: [{ confidence: '0.7401', content: 'my' }],
        type: 'pronunciation'
      },
      {
        start_time: '3.7',
        end_time: '4.03',
        alternatives: [{ confidence: '0.2648', content: 'Uncles' }],
        type: 'pronunciation'
      },
      {
        start_time: '4.03',
        end_time: '5.11',
        alternatives: [{ confidence: '0.9175', content: 'Grand' }],
        type: 'pronunciation'
      },
      {
        start_time: '5.11',
        end_time: '6.7',
        alternatives: [{ confidence: '0.8511', content: 'Podcast' }],
        type: 'pronunciation'
      },
      {
        alternatives: [{ confidence: '0.0', content: ',' }],
        type: 'punctuation'
      },
      {
        start_time: '6.71',
        end_time: '6.83',
        alternatives: [{ confidence: '0.9949', content: 'a' }],
        type: 'pronunciation'
      },
      {
        start_time: '6.83',
        end_time: '7.16',
        alternatives: [{ confidence: '1.0', content: 'weekly' }],
        type: 'pronunciation'
      },
      {
        start_time: '7.16',
        end_time: '7.61',
        alternatives: [{ confidence: '0.9905', content: 'podcast' }],
        type: 'pronunciation'
      },
      {
        start_time: '7.61',
        end_time: '7.75',
        alternatives: [{ confidence: '0.992', content: 'where' }],
        type: 'pronunciation'
      },
      {
        start_time: '7.75',
        end_time: '7.87',
        alternatives: [{ confidence: '0.9978', content: 'we' }],
        type: 'pronunciation'
      },
      {
        start_time: '7.87',
        end_time: '8.19',
        alternatives: [{ confidence: '0.9936', content: 'figure' }],
        type: 'pronunciation'
      },
      {
        start_time: '8.19',
        end_time: '8.35',
        alternatives: [{ confidence: '1.0', content: 'out' }],
        type: 'pronunciation'
      },
      {
        start_time: '8.35',
        end_time: '9.1',
        alternatives: [{ confidence: '0.9995', content: 'what' }],
        type: 'pronunciation'
      },
      {
        start_time: '9.11',
        end_time: '10.93',
        alternatives: [{ confidence: '1.0', content: 'we' }],
        type: 'pronunciation'
      },
      {
        start_time: '10.93',
        end_time: '11.48',
        alternatives: [{ confidence: '1.0', content: 'think' }],
        type: 'pronunciation'
      },
      {
        start_time: '11.49',
        end_time: '11.66',
        alternatives: [{ confidence: '0.9922', content: 'is' }],
        type: 'pronunciation'
      },
      {
        start_time: '11.66',
        end_time: '12.06',
        alternatives: [{ confidence: '1.0', content: 'going' }],
        type: 'pronunciation'
      },
      {
        start_time: '12.06',
        end_time: '12.58',
        alternatives: [{ confidence: '1.0', content: 'on' }],
        type: 'pronunciation'
      },
      {
        start_time: '12.59',
        end_time: '13.33',
        alternatives: [{ confidence: '1.0', content: 'and' }],
        type: 'pronunciation'
      },
      {
        start_time: '13.34',
        end_time: '13.67',
        alternatives: [{ confidence: '1.0', content: 'figure' }],
        type: 'pronunciation'
      },
      {
        start_time: '13.67',
        end_time: '14.05',
        alternatives: [{ confidence: '1.0', content: 'out' }],
        type: 'pronunciation'
      },
      {
        start_time: '14.06',
        end_time: '14.23',
        alternatives: [{ confidence: '1.0', content: 'what' }],
        type: 'pronunciation'
      },
      {
        start_time: '14.23',
        end_time: '14.33',
        alternatives: [{ confidence: '0.9308', content: 'we' }],
        type: 'pronunciation'
      },
      {
        start_time: '14.33',
        end_time: '14.52',
        alternatives: [{ confidence: '0.9858', content: 'think' }],
        type: 'pronunciation'
      },
      {
        start_time: '14.52',
        end_time: '14.73',
        alternatives: [{ confidence: '0.7094', content: 'about' }],
        type: 'pronunciation'
      },
      {
        start_time: '14.73',
        end_time: '15.24',
        alternatives: [{ confidence: '1.0', content: 'stuff' }],
        type: 'pronunciation'
      },
      {
        start_time: '15.25',
        end_time: '15.92',
        alternatives: [{ confidence: '1.0', content: 'and' }],
        type: 'pronunciation'
      },
      {
        start_time: '15.93',
        end_time: '16.39',
        alternatives: [{ confidence: '0.9805', content: 'talk' }],
        type: 'pronunciation'
      },
      {
        start_time: '16.39',
        end_time: '16.71',
        alternatives: [{ confidence: '0.9325', content: 'about' }],
        type: 'pronunciation'
      },
      {
        start_time: '16.71',
        end_time: '17.36',
        alternatives: [{ confidence: '1.0', content: 'stuff' }],
        type: 'pronunciation'
      },
      {
        alternatives: [{ confidence: '0.0', content: '.' }],
        type: 'punctuation'
      },
      {
        start_time: '17.37',
        end_time: '17.81',
        alternatives: [{ confidence: '0.9969', content: 'My' }],
        type: 'pronunciation'
      },
      {
        start_time: '17.81',
        end_time: '17.95',
        alternatives: [{ confidence: '0.7088', content: 'name' }],
        type: 'pronunciation'
      },
      {
        start_time: '17.95',
        end_time: '18.03',
        alternatives: [{ confidence: '0.7019', content: 'is' }],
        type: 'pronunciation'
      },
      {
        start_time: '18.03',
        end_time: '18.3',
        alternatives: [{ confidence: '0.9016', content: 'Michael' }],
        type: 'pronunciation'
      },
      {
        start_time: '18.3',
        end_time: '18.95',
        alternatives: [{ confidence: '0.9565', content: 'Forest' }],
        type: 'pronunciation'
      },
      {
        alternatives: [{ confidence: '0.0', content: ',' }],
        type: 'punctuation'
      },
      {
        start_time: '18.96',
        end_time: '19.15',
        alternatives: [{ confidence: '0.9939', content: 'and' }],
        type: 'pronunciation'
      },
      {
        start_time: '19.15',
        end_time: '19.36',
        alternatives: [{ confidence: '0.735', content: "I'm" }],
        type: 'pronunciation'
      },
      {
        start_time: '19.62',
        end_time: '20.36',
        alternatives: [{ confidence: '0.9923', content: 'magic' }],
        type: 'pronunciation'
      },
      {
        alternatives: [{ confidence: '0.0', content: '.' }],
        type: 'punctuation'
      }
    ]
  },
  status: 'COMPLETED'
};



// WEBPACK FOOTER //
// ./src/captions/podcast-test-1.ts